export default __webpack_public_path__ + "fonts/PreForeclosures-White.svg";